import React, {ChangeEvent} from "react"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import Grid from "@mui/material/Grid"
import Input from "@mui/material/Input"
import Select, {SelectChangeEvent} from "@mui/material/Select"
import {useDispatch, useSelector} from "../../store";

import {useTranslation} from "next-i18next"

import continents from "../../generated/continents.json"
import {addMonths, format} from "date-fns"
import {enUS} from "date-fns/locale"
import {dateFormat} from "../../lib/date-format"
import {getTrips, setCriteriaContinent, setCriteriaPeriod} from "../../slices/trips-slice";
import {Box} from "@mui/material";
import {useRouter} from "next-translate-routes/router";

export const SearchBar = () => {

    const {t, i18n} = useTranslation()

    const {criteria} = useSelector((state) => state.trips);

    const {selectedContinent, selectedPeriod} = criteria


    const dispatch = useDispatch()

    const router = useRouter()

    const handleCriteriaChanged = (e: SelectChangeEvent) => {
        if (e.target.name === "diveContinent") {
            const selectedContinentSlug = (continents.filter((c: any) => c.continentId == e.target.value).map((c: any) => c.slug[i18n.language].current))[0] || ""
            router.replace('/diving', `/diving/${selectedContinentSlug}`, {unstable_skipClientCache: true, shallow: true} )
            dispatch(setCriteriaContinent(e.target.value));
        } else if (e.target.name === "divePeriod") {
            dispatch(setCriteriaPeriod(e.target.value));
            //setQuery({divePeriod: e.target.value});
        }

        dispatch(getTrips({language: i18n.language}));

    };


    return <Box sx={{flexGrow: 1, backgroundColor: "#0D677A", mt: 0, p: 3}}>
        <Grid container justifyContent='center' alignItems='flex-end' spacing={3}>

            <Grid item xs={12} md={5} lg={4} xl={3}>
                <FormControl component='fieldset' sx={{
                    fontWeight: 400,
                    display: "block"
                }}>
                    <FormLabel component='label'
                               sx={{
                                   mr: 1,
                                   color: "white",
                                   fontFamily: "Neutra Text TF",
                                   textTransform: "uppercase",
                                   "&.Mui-focused": {
                                       color: "white",
                                   }
                               }}
                    >{t("where-do-you-want-to-go")}</FormLabel>
                    <br/>
                    <Select
                        disableUnderline
                        native
                        onChange={handleCriteriaChanged}
                        value={selectedContinent}
                        input={<Input name='diveContinent' id='diveContinent'/>}
                        sx={{
                            background: "white",
                            padding: "4px",
                            paddingLeft: "10px",
                            width: "100%",

                        }}
                    >
                        <option value=''>{t("anywhere")}</option>
                        {continents.map((continent: any, idx: number) => {
                            return <option key={idx}
                                           value={continent.continentId}>{continent.title[i18n.language]}</option>
                        })}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={12} md={5} lg={4} xl={3}>
                <FormControl component='fieldset'
                             sx={{
                                 fontWeight: 400,
                                 display: "block"
                             }}>
                    <FormLabel component='label'
                               sx={{
                                   color: "white",
                                   fontFamily: "Neutra Text TF",
                                   textTransform: "uppercase",
                                   "&.Mui-focused": {
                                       color: "white",
                                   }
                               }}
                    >{t("when-do-you-want-to-go")}</FormLabel>
                    <br/>
                    <Select
                        disableUnderline
                        native
                        onChange={handleCriteriaChanged}
                        value={selectedPeriod}
                        input={<Input name='divePeriod' id='divePeriod'/>}
                        sx={{
                            background: "white",
                            padding: "4px",
                            paddingLeft: "10px",
                            width: "100%"
                        }}
                    >
                        <option value=''>{t("period-anytime")}</option>

                        {[...Array(36)].map((x, i) => {
                                let myDate = addMonths(new Date(), i)

                                return <option key={i}
                                               value={format(myDate, "yyyy-MMM", {locale: enUS}).toLowerCase()}>{dateFormat(myDate, "MMMM yyyy", i18n.language)}</option>

                            }
                        )}


                    </Select>
                </FormControl>
            </Grid>

        </Grid>

    </Box>

}

